module.exports = __webpack_public_path__ + "img/2010 winteressen 013.e4f0a6df.jpg";